<template>
  <BaseContentWrapper class="base-list-item">
    <div class="base-list-item__title">
      <slot name="title" />
    </div>
    <div>
      <slot name="actions" />
    </div>
    <div
      v-if="$scopedSlots.badges"
      class="base-list-item__badges">
      <slot name="badges" />
    </div>
  </BaseContentWrapper>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.base-list-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: bold;
  }

  &__badges {
    display: flex;
    gap: 0 4px;
    position: absolute;
    top: -8px;
    right: 16px;
  }
}
</style>